import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { lookItemShipHistory } from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import { Link } from "react-router-dom";

class ViewItemShipmentHistory extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.itemNumber,
        whse: value.header.wse,
        year: value.header.year
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      // this.newInfo = {};
      this.newInfo.itemNumber = parseInt(this.newInfo.itemNumber, 10);
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };

  lookup = msg => {
    if (
      this.state.lookup &&
      this.state.lookup.item !== undefined &&
      this.state.lookup.whse !== undefined &&
      this.state.lookup.year !== undefined
    ) {
      this.setTransitioMessage(<Spinner msg="Loading..." />);
      var item = parseInt(this.state.lookup.item, 10).toString();

      lookItemShipHistory(
        item,
        this.state.lookup.whse,
        this.state.lookup.year
      ).then(res => {
        const data = res.data.data;
        var arrWeeks = [];

        if (res.data.success) {
          msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
          // const whsesForItem = res.data.data.whsesForItem;
          // delete data.whsesForItem;
          arrWeeks = [];

          for (let i = 1; i < 57; i++) {
            arrWeeks.push({
              label: i,
              value: res.data.data[`week${i}Sales`],
              name: `week${i}Sales`
            });
          }
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                // value: res.data.data.itemNumber,
                name: "itemNumber"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "WareHouse",
               // value: res.data.data.whsesForItem /* */,
                name: "wse"
              },
              {
                label: "Year",
                value: res.data.data.year,
                name: "year"
              }
            ],
            cards: [
              {
                Card1: [
                  {
                    label: "",
                    value: "",
                    name: "placeHolder1"
                  },
                  {
                    label: "Unit Shipped",
                    value: "",
                    name: "unitShippedTag"
                  },
                  {
                    label: "Dollar Value",
                    value: "",
                    name: "dollarValueTag"
                  },
                  {
                    label: "Units Received",
                    value: "",
                    name: "unitsReceivedTag"
                  },
                  {
                    label: "Units Out",
                    value: "",
                    name: "unitsOutTag"
                  },
                  {
                    label: "Deseasonalized Demand",

                    value: res.data.data.infDD,
                    name: "infDD"
                  },
                  {
                    label: "Current Week To Date",

                    value: "",
                    name: "cwD"
                  },
                  {
                    label: res.data.data.cwSalesUnits,

                    value: "",
                    name: "cwSalesUnits"
                  },
                  {
                    label: res.data.data.cwCost,
                    value: "",
                    name: "cwCost"
                  },
                  {
                    label: res.data.data.cwReceiptsUnits,

                    value: "",
                    name: "cwReceiptsUnits"
                  },
                  {
                    label: res.data.data.cwUnitOuts,

                    value: "",
                    name: "cwUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder2"
                  },
                  {
                    label: "Current Period To Date",

                    value: "",
                    name: "cpD"
                  },
                  {
                    label: res.data.data.cpSalesUnits,

                    value: "",
                    name: "cpSalesUnits"
                  },
                  {
                    label: res.data.data.cpCost,

                    value: "",
                    name: "cpCost"
                  },
                  {
                    label: res.data.data.cpReceiptsUnits,

                    value: "",
                    name: "cpReceiptsUnits"
                  },
                  {
                    label: res.data.data.cpUnitOuts,

                    value: "",
                    name: "cpUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder3"
                  },

                  {
                    label: "Current Year To Date",

                    value: "",
                    name: "yrD"
                  },
                  {
                    label: res.data.data.yrSalesUnits,

                    value: "",
                    name: "yrSalesUnits"
                  },
                  {
                    label: res.data.data.yrCost,

                    value: "",
                    name: "yrCost"
                  },
                  {
                    label: res.data.data.yrReceiptsUnits,

                    value: "",
                    name: "yrReceiptsUnits"
                  },
                  {
                    label: res.data.data.yrUnitOuts,

                    value: "",
                    name: "yrUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder4"
                  }
                ]
              },
              { Card2: arrWeeks }
            ]
          });
        } else {
          arrWeeks = [];

          for (let i = 1; i < 57; i++) {
            arrWeeks.push({
              label: i,
              //value: res.data.data[`week${i}Sales`],
              name: `week${i}Sales`
            });
          }
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(this.state.lookup.item, 9),
                // value: res.data.data.itemNumber,
                name: "itemNumber"
              },
              {
                label: "Description",
                value: "",
                name: "description"
              },
              {
                label: "WareHouse",
                value: "",
                name: "wse"
              },
              {
                label: "Year",
                value: this.state.lookup.year,
                name: "year"
              }
            ],
            cards: [
              {
                Card1: [
                  {
                    label: "",
                    value: "",
                    name: "placeHolder1"
                  },
                  {
                    label: "Unit Shipped",
                    value: "",
                    name: "unitShippedTag"
                  },
                  {
                    label: "Dollar Value",
                    value: "",
                    name: "dollarValueTag"
                  },
                  {
                    label: "Units Received",
                    value: "",
                    name: "unitsReceivedTag"
                  },
                  {
                    label: "Units Out",
                    value: "",
                    name: "unitsOutTag"
                  },
                  {
                    label: "Deseasonalized Demand",

                    value: "",
                    name: "infDD"
                  },
                  {
                    label: "Current Week To Date",

                    value: "",
                    name: "cwD"
                  },
                  {
                    // label: res.data.data.cwSalesUnits,

                    value: "",
                    name: "cwSalesUnits"
                  },
                  {
                    // label: res.data.data.cwCost,
                    value: "",
                    name: "cwCost"
                  },
                  {
                    // label: res.data.data.cwReceiptsUnits,

                    value: "",
                    name: "cwReceiptsUnits"
                  },
                  {
                    // label: res.data.data.cwUnitOuts,

                    value: "",
                    name: "cwUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder2"
                  },
                  {
                    label: "Current Period To Date",

                    value: "",
                    name: "cpD"
                  },
                  {
                    // label: res.data.data.cpSalesUnits,

                    value: "",
                    name: "cpSalesUnits"
                  },
                  {
                    // label: res.data.data.cpCost,

                    value: "",
                    name: "cpCost"
                  },
                  {
                    // label: res.data.data.cpReceiptsUnits,

                    value: "",
                    name: "cpReceiptsUnits"
                  },
                  {
                    // label: res.data.data.cpUnitOuts,

                    value: "",
                    name: "cpUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder3"
                  },

                  {
                    label: "Current Year To Date",

                    value: "",
                    name: "yrD"
                  },
                  {
                    // label: res.data.data.yrSalesUnits,

                    value: "",
                    name: "yrSalesUnits"
                  },
                  {
                    // label: res.data.data.yrCost,

                    value: "",
                    name: "yrCost"
                  },
                  {
                    // label: res.data.data.yrReceiptsUnits,

                    value: "",
                    name: "yrReceiptsUnits"
                  },
                  {
                    // label: res.data.data.yrUnitOuts,

                    value: "",
                    name: "yrUnitOuts"
                  },
                  {
                    label: "",

                    value: "",
                    name: "placeHolder4"
                  }
                ]
              },
              { Card2: arrWeeks }
            ]
          });
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage(
        "Please select a valid combination of Item number + Warehouse + Year"
      );
    }
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
      this.setErrorMessage("");
    }
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }
  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item Shipment History By DC
        </h3>
        {/* <input onClick={e => this.lookup()} type="submit" value={"populate"} /> */}
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Link to="/" className="sub-menu-item-tag">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
            </Link>

            {/* <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button> */}
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}
export default ViewItemShipmentHistory;
